import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
    class: "sc-select"
};
const _hoisted_2 = {
    key: 0,
    class: "sc-select-loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_icon_loading = _resolveComponent("el-icon-loading");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_option = _resolveComponent("el-option");
    const _component_el_select = _resolveComponent("el-select");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        $data.initloading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_icon, {
                class: "is-loading"
            }, {
                default: _withCtx(()=>[
                        _createVNode(_component_el_icon_loading)
                    ]),
                _: 1
            })
        ])) : _createCommentVNode("", true),
        _createVNode(_component_el_select, _mergeProps(_ctx.$attrs, {
            loading: $data.loading,
            onVisibleChange: $options.visibleChange
        }), {
            default: _withCtx(()=>[
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, (item)=>{
                        return _openBlock(), _createBlock(_component_el_option, {
                            key: item[$data.props.value],
                            label: item[$data.props.label],
                            value: $props.objValueType ? item : item[$data.props.value]
                        }, {
                            default: _withCtx(()=>[
                                    _renderSlot(_ctx.$slots, "option", {
                                        data: item
                                    }, undefined, true)
                                ]),
                            _: 2
                        }, 1032, [
                            "label",
                            "value"
                        ]);
                    }), 128))
                ]),
            _: 3
        }, 16, [
            "loading",
            "onVisibleChange"
        ])
    ]);
}
